import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.map.get-or-insert.js";
import "core-js/modules/es.map.get-or-insert-computed.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getFlowRecordById, complete, taskReject, taskReturn, nextFlowNode, stopProcess, queryFormFillByProcInsId, queryWaitMeApplys } from '@/services/form';
import { saveFlowCopyMan } from '@/services/flow';
import selectPerson from '@/components/select-person/genera';
import config from '@/pathConfig';
export default {
  name: 'AuditProcess',
  components: {
    selectPerson: selectPerson
  },
  data: function data() {
    var usersTabList = [{
      title: '组织',
      value: 0
    }, {
      title: '组织岗位',
      value: 2
    }, {
      title: '组织岗位成员',
      value: 3
    }];
    var userGroupTabList = [{
      title: '组织岗位',
      value: 2
    }, {
      title: '组织岗位成员',
      value: 3
    }];
    return {
      defaultOrganPostValue: '',
      form1: {},
      returnVisible: false,
      sliderbar: true,
      sliderbarShow: true,
      usersList: {},
      userGroupObj: {},
      usersTabList: usersTabList,
      userGroupTabList: userGroupTabList,
      procInsId: '',
      taskId: '',
      targetKey: '',
      flowListRaw: [],
      mergedFlowList: [],
      newflowList: [],
      flowFromData: {},
      formData: {
        list: [],
        config: {
          labelWidth: 100,
          labelPosition: 'right',
          size: 'small',
          customClass: '',
          ui: 'element',
          layout: 'horizontal',
          labelCol: 3,
          width: '100%',
          hideLabel: false,
          hideErrorMessage: false
        }
      },
      fillData: {},
      comment: '',
      auditUserVisible: false,
      flowApproverSetList: [],
      nextAuditUser: '',
      nextAuditUsers: [],
      nextAuditUserFlag: false,
      nextAuditUserType: '',
      nextAuditGroup: '',
      stopLoading: false,
      stopVisible: false,
      tipMsg: '',
      hasCustomLabel: false,
      inputSize: 0,
      inputKeyList: [],
      inputTypeList: [],
      signImgUrl: '',
      formObject: {
        organPostId: [],
        inputValueList: []
      },
      options: [],
      userInfo: this.$hdk.userInfo.get(),
      rules: {
        organPostId: [{
          required: true,
          message: '请选择所属组织及岗位'
        }]
      },
      valided: false,
      path: '',
      currCheck: {
        comment: '',
        userName: '',
        deptName: ''
      },
      continueModalVisible: false,
      sinceFillId: '',
      searchParams: {
        formName: '',
        category: '',
        beginTime: '',
        endTime: '',
        summary: '',
        fillId: ''
      }
    };
  },
  methods: {
    mergeMultiInstanceTasks: function mergeMultiInstanceTasks(flowList) {
      var groupMap = new Map();
      var normalList = [];
      flowList.forEach(function (item) {
        if (item.multiInstance && item.multiInstanceGroupId) {
          var groupId = item.multiInstanceGroupId;
          if (!groupMap.has(groupId)) {
            var _group = _objectSpread(_objectSpread({}, item), {}, {
              subTasks: [],
              multiInstance: true,
              assigneeName: undefined,
              comment: undefined,
              expanded: false
            });
            groupMap.set(groupId, _group);
          }
          var group = groupMap.get(groupId);
          group.subTasks.push(item);
          if (!group.createTime || item.createTime && item.createTime < group.createTime) {
            group.createTime = item.createTime;
          }
          if (!group.finishTime || item.finishTime && item.finishTime > group.finishTime) {
            group.finishTime = item.finishTime;
          }
        } else {
          normalList.push(item);
        }
      });
      var groupList = Array.from(groupMap.values());
      var allItems = [].concat(normalList, groupList);
      allItems.sort(function (a, b) {
        return new Date(a.createTime) - new Date(b.createTime);
      });
      return allItems;
    },
    toggleGroupExpand: function toggleGroupExpand(item) {
      this.$set(item, 'expanded', !item.expanded);
    },
    getCircleColor: function getCircleColor(item) {
      var col;
      if (item.multiInstance && item.subTasks && item.subTasks.length) {
        var _item$subTasks$;
        col = this.getTagColor((_item$subTasks$ = item.subTasks[0]) === null || _item$subTasks$ === void 0 || (_item$subTasks$ = _item$subTasks$.comment) === null || _item$subTasks$ === void 0 ? void 0 : _item$subTasks$.type);
      } else {
        var _item$comment;
        col = this.getTagColor((_item$comment = item.comment) === null || _item$comment === void 0 ? void 0 : _item$comment.type);
      }
      if (col == undefined) col = this.getTagColor('0');
      return col;
    },
    getTagColor: function getTagColor(type) {
      var _colors$find;
      var colors = [{
        itemVal: 'rgba(255, 152, 6, 0.8)',
        itemKey: '3'
      }, {
        itemVal: 'rgba(255, 152, 6, 0.8)',
        itemKey: '2'
      }, {
        itemVal: 'rgba(79, 191, 73, 0.8)',
        itemKey: '1'
      }, {
        itemVal: 'rgba(220, 33, 39, 0.8)',
        itemKey: '6'
      }, {
        itemVal: 'rgba(24, 144, 255, 0.8)',
        itemKey: '0'
      }];
      return (_colors$find = colors.find(function (item) {
        return item.itemKey == type;
      })) === null || _colors$find === void 0 ? void 0 : _colors$find.itemVal;
    },
    getTagMsg: function getTagMsg(type) {
      var _msg$find;
      var msg = [{
        itemVal: '驳回',
        itemKey: '3'
      }, {
        itemVal: '通过',
        itemKey: '1'
      }, {
        itemVal: '不通过',
        itemKey: '6'
      }];
      return (_msg$find = msg.find(function (item) {
        return item.itemKey == type;
      })) === null || _msg$find === void 0 ? void 0 : _msg$find.itemVal;
    },
    formartDept: function formartDept(dept) {
      if (dept) {
        var depts = dept.split('/');
        if (depts.length > 1) return depts[0] + '...';else return dept;
      }
    },
    clickChange: function clickChange() {
      this.sliderbar = !this.sliderbar;
      this.sliderbarShow = true;
    },
    onOrganAndJob: function onOrganAndJob(value) {
      var _this = this;
      var $set = this.$set,
        formObject = this.formObject,
        options = this.options;
      options.forEach(function (item, index) {
        if (index === value) {
          $set(formObject, 'organId', item.organId);
          $set(formObject, 'postId', item.postId);
          _this.formObject.customize = {};
          _this.formObject.customize.organId = item.organId;
          _this.formObject.customize.postId = item.postId;
          _this.formObject.organPostId[1] = item.postId;
          _this.formObject.organPostId[0] = item.organId;
        }
      });
    },
    filterOption: function filterOption(inputValue, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0;
    },
    onloadFlowRecord: function onloadFlowRecord() {
      var _this2 = this;
      getFlowRecordById(this.procInsId).then(function (res) {
        if (res.data.code == 200) {
          _this2.flowListRaw = res.data.data.flowList || [];
          _this2.mergedFlowList = _this2.mergeMultiInstanceTasks(_this2.flowListRaw);
          if (_this2.flowListRaw.length > 0) {
            var flowObj = _this2.flowListRaw[_this2.flowListRaw.length - 1];
            // 组织岗位选项
            if (flowObj.userOPs && flowObj.userOPs.length != 0) {
              _this2.defaultOrganPostValue = 0;
              _this2.options = flowObj.userOPs;
              _this2.$set(_this2.formObject, 'organId', flowObj.userOPs[0].organId);
              _this2.$set(_this2.formObject, 'postId', flowObj.userOPs[0].postId);
              _this2.formObject.customize = {};
              _this2.formObject.customize.organId = flowObj.userOPs[0].organId;
              _this2.formObject.customize.postId = flowObj.userOPs[0].postId;
              _this2.formObject.organPostId[1] = flowObj.userOPs[0].postId;
              _this2.formObject.organPostId[0] = flowObj.userOPs[0].organId;
            }
            // 自定义审批标签
            var attrs = flowObj.flowCustomLabelMap;
            _this2.hasCustomLabel = !(JSON.stringify(attrs) == '{}');
            if (_this2.hasCustomLabel) {
              _this2.inputSize = parseInt(attrs.inputSize);
              _this2.inputKeyList = attrs.inputKeyList.split(',');
              _this2.inputTypeList = attrs.inputTypeList.split(',');
            }
            // 关键：渲染表单数据
            if (flowObj.formDta && flowObj.formDta.formData) {
              var formDataJson = JSON.parse(flowObj.formDta.formData);
              var fillDataJson = typeof flowObj.formDta.fillData == 'string' ? JSON.parse(flowObj.formDta.fillData) : flowObj.formDta.fillData;
              _this2.$set(_this2.formData, 'list', formDataJson.list);
              _this2.$set(_this2.formData, 'config', formDataJson.config);
              _this2.fillData = fillDataJson;
              _this2.$nextTick(function () {
                if (_this2.$refs.generateForm) {
                  _this2.$refs.generateForm.refresh();
                  _this2.$refs.generateForm.setData(_this2.fillData);
                }
              });
            }
            // 当前节点申请人信息
            if (flowObj.deptId != undefined && flowObj.deptId != null) {
              var deptIdArr = flowObj.deptId.split(':');
              if (deptIdArr && deptIdArr.length > 1 && deptIdArr[1] != 'null') {
                _this2.setCurrCheck(Number(deptIdArr[0]), Number(deptIdArr[1]), flowObj.comment);
              }
            } else {
              queryFormFillByProcInsId({
                procInsId: _this2.procInsId
              }).then(function (res) {
                if (res.data.code == 200) {
                  if (!_this2.fillData || Object.keys(_this2.fillData).length === 0) {
                    var _fillDataJson = typeof res.data.data.fillData == 'string' ? JSON.parse(res.data.data.fillData) : res.data.data.fillData;
                    _this2.fillData = _fillDataJson;
                    _this2.$nextTick(function () {
                      if (_this2.$refs.generateForm) {
                        _this2.$refs.generateForm.refresh();
                        _this2.$refs.generateForm.setData(_this2.fillData);
                      }
                    });
                  }
                  _this2.setCurrCheck(Number(res.data.data.organId), Number(res.data.data.postId), flowObj.comment);
                }
              });
            }
          }
        }
      });
    },
    setCurrCheck: function setCurrCheck(organId, postId, comment) {
      this.currCheck.userName = this.userInfo.userName;
      this.currCheck.comment = comment;
      var d1 = '',
        d2 = '';
      _.map(this.userInfo.organPostTree, function (item) {
        _.map(item.postList, function (subItem) {
          if (subItem.value === Number(postId)) d2 = subItem.label;
        });
        if (item.organId === Number(organId)) d1 = item.organName;
      });
      this.currCheck.deptName = d1 + '/' + d2;
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    getCopyManData: function getCopyManData() {
      var copyManData = [];
      if (Object.prototype.hasOwnProperty.call(this.usersList, 'organData')) {
        var organData = this.usersList.organData.map(function (item) {
          return {
            copy_type: 2,
            type_id: item.typeId,
            organ_id: item.actorId,
            post_id: new Number(),
            user_id: new Number()
          };
        });
        copyManData = copyManData.concat(organData);
      }
      if (Object.prototype.hasOwnProperty.call(this.usersList, 'postData')) {
        var postData = this.usersList.postData.map(function (item) {
          return {
            copy_type: 1,
            type_id: new Number(),
            organ_id: item.organId,
            post_id: item.actorId,
            user_id: new Number()
          };
        });
        copyManData = copyManData.concat(postData);
      }
      if (Object.prototype.hasOwnProperty.call(this.usersList, 'userData')) {
        var userData = this.usersList.userData.map(function (item) {
          return {
            copy_type: 0,
            type_id: new Number(),
            organ_id: new Number(),
            post_id: new Number(),
            user_id: item.actorId
          };
        });
        copyManData = copyManData.concat(userData);
      }
      return copyManData;
    },
    onClickAudit: function onClickAudit() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var copyManData, res, param, _this3$flowListRaw$, _this3$flowListRaw$2, param2, _this3$flowListRaw$3, _this3$flowListRaw$4, _param;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this3.$refs.addForm.validate(function (valid) {
                if (valid) _this3.valided = true;
              });
              if (!_this3.valided) {
                _context.n = 3;
                break;
              }
              _context.n = 1;
              return _this3.getCopyManData();
            case 1:
              copyManData = _context.v;
              _context.n = 2;
              return nextFlowNode({
                taskId: _this3.taskId,
                procInsId: _this3.procInsId
              });
            case 2:
              res = _context.v;
              if (res.data.code == 200) {
                param = {
                  taskId: _this3.taskId,
                  nextNodeCliamUserId: '',
                  nextNodeUserType: '',
                  comment: _this3.comment,
                  values: {
                    organId: _this3.formObject.organPostId[0],
                    postId: _this3.formObject.organPostId[1]
                  },
                  flowCustomLabelMap: {
                    inputKeyList: _this3.inputKeyList,
                    inputValueList: _this3.formObject.inputValueList,
                    inputTypeList: _this3.inputTypeList
                  }
                };
                if (res.data.data == undefined) {
                  _this3.completeTask(param);
                  if (copyManData != undefined && copyManData.length > 0) {
                    param2 = {
                      processInstanceId: _this3.procInsId,
                      copyManData: copyManData,
                      organPost: {
                        organId: _this3.formObject.organPostId[0],
                        postId: _this3.formObject.organPostId[1]
                      },
                      startUserName: (_this3$flowListRaw$ = _this3.flowListRaw[0]) === null || _this3$flowListRaw$ === void 0 ? void 0 : _this3$flowListRaw$.assigneeName,
                      startUserDeptName: (_this3$flowListRaw$2 = _this3.flowListRaw[0]) === null || _this3$flowListRaw$2 === void 0 ? void 0 : _this3$flowListRaw$2.deptName
                    };
                    _this3.saveFlowCopyManFunc(param2);
                  }
                } else if (Object.keys(res.data.data).length > 0) {
                  if (res.data.message == '自由选择') {
                    _this3.auditUserVisible = true;
                    _this3.flowApproverSetList = res.data.data;
                  } else {
                    _this3.completeTask(param);
                    if (copyManData != undefined && copyManData.length > 0) {
                      _param = {
                        processInstanceId: _this3.procInsId,
                        copyManData: copyManData,
                        organPost: {
                          organId: _this3.formObject.organPostId[0],
                          postId: _this3.formObject.organPostId[1]
                        },
                        startUserName: (_this3$flowListRaw$3 = _this3.flowListRaw[0]) === null || _this3$flowListRaw$3 === void 0 ? void 0 : _this3$flowListRaw$3.assigneeName,
                        startUserDeptName: (_this3$flowListRaw$4 = _this3.flowListRaw[0]) === null || _this3$flowListRaw$4 === void 0 ? void 0 : _this3$flowListRaw$4.deptName
                      };
                      _this3.saveFlowCopyManFunc(_param);
                    }
                  }
                }
              }
            case 3:
              _this3.valided = false;
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    completeTask: function completeTask(param) {
      var _this4 = this;
      complete(param).then(function (res) {
        if (res.data.code == 200) {
          _this4.$message.success('审核成功');
          _this4.auditUserVisible = false;
          _this4.showContinueModal();
        }
      });
    },
    saveFlowCopyManFunc: function saveFlowCopyManFunc(param) {
      saveFlowCopyMan(param).then(function (res) {
        return void 0;
      });
    },
    onClickReturn: function onClickReturn() {
      var map = {};
      this.flowListRaw.forEach(function (item) {
        var key = item.taskDefKey;
        if (!map[key]) {
          map[key] = {
            taskDefKey: key,
            taskNames: [item.taskName],
            firstItem: item
          };
        } else if (!map[key].taskNames.includes(item.taskName)) {
          map[key].taskNames.push(item.taskName);
        }
      });
      this.newflowList = Object.values(map).map(function (item) {
        return {
          taskDefKey: item.taskDefKey,
          taskName: item.taskNames.join('、')
        };
      });
      this.newflowList.pop();
      this.returnVisible = true;
    },
    handleOk: function handleOk(e) {
      var _this5 = this;
      this.nextAuditUserFlag = true;
      this.flowApproverSetList.map(function (item) {
        var node = _this5.userGroupObj[item.taskDefKey];
        if (!node || JSON.stringify(node) == '{}' || node.postData.length == 0 && node.userData.length == 0) {
          _this5.$message.info('请选择节点: "' + item.taskName + '" 的审核人');
          _this5.nextAuditUserFlag = false;
        }
      });
      if (!this.nextAuditUserFlag) return;
      var copyManData = this.getCopyManData();
      var param = {
        taskId: this.taskId,
        approverSetMap: this.userGroupObj,
        comment: this.comment,
        values: {
          organId: this.formObject.organPostId[0],
          postId: this.formObject.organPostId[1]
        },
        flowCustomLabelMap: {
          inputKeyList: this.inputKeyList,
          inputValueList: this.formObject.inputValueList,
          inputTypeList: this.inputTypeList
        }
      };
      this.completeTask(param);
      if (copyManData != undefined && copyManData.length > 0) {
        var _this$flowListRaw$, _this$flowListRaw$2;
        var param2 = {
          processInstanceId: this.procInsId,
          copyManData: copyManData,
          organPost: {
            organId: this.formObject.organPostId[0],
            postId: this.formObject.organPostId[1]
          },
          startUserName: (_this$flowListRaw$ = this.flowListRaw[0]) === null || _this$flowListRaw$ === void 0 ? void 0 : _this$flowListRaw$.assigneeName,
          startUserDeptName: (_this$flowListRaw$2 = this.flowListRaw[0]) === null || _this$flowListRaw$2 === void 0 ? void 0 : _this$flowListRaw$2.deptName
        };
        this.saveFlowCopyManFunc(param2);
      }
    },
    handleCancel: function handleCancel(e) {
      this.auditUserVisible = false;
    },
    returnHandleCancel: function returnHandleCancel(e) {
      this.returnVisible = false;
    },
    returnHandleOk: function returnHandleOk(e) {
      var _this6 = this;
      taskReturn({
        taskId: this.taskId,
        procInsId: this.procInsId,
        targetKey: this.targetKey,
        comment: this.comment,
        values: {
          organId: this.formObject.organPostId[0],
          postId: this.formObject.organPostId[1]
        },
        flowCustomLabelMap: {
          inputKeyList: this.inputKeyList,
          inputValueList: this.formObject.inputValueList,
          inputTypeList: this.inputTypeList
        }
      }).then(function (res) {
        if (res.data.code == 200) {
          _this6.$message.success('驳回成功');
          _this6.showContinueModal();
        }
      });
      var copyManData = this.getCopyManData();
      if (copyManData != undefined && copyManData.length > 0) {
        var _this$flowListRaw$3, _this$flowListRaw$4;
        var param2 = {
          processInstanceId: this.procInsId,
          copyManData: copyManData,
          organPost: {
            organId: this.formObject.organPostId[0],
            postId: this.formObject.organPostId[1]
          },
          startUserName: (_this$flowListRaw$3 = this.flowListRaw[0]) === null || _this$flowListRaw$3 === void 0 ? void 0 : _this$flowListRaw$3.assigneeName,
          startUserDeptName: (_this$flowListRaw$4 = this.flowListRaw[0]) === null || _this$flowListRaw$4 === void 0 ? void 0 : _this$flowListRaw$4.deptName
        };
        this.saveFlowCopyManFunc(param2);
      }
    },
    onClickStop: function onClickStop() {
      var _this7 = this;
      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          _this7.$confirm('确认终止流程?', '提示', {
            type: 'warning',
            confirmButtonText: '确 认',
            cancelButtonText: '取 消'
          }).then(function () {
            stopProcess({
              taskId: _this7.taskId,
              procInsId: _this7.procInsId,
              comment: _this7.comment,
              values: {
                organId: _this7.formObject.organPostId[0],
                postId: _this7.formObject.organPostId[1]
              }
            }).then(function (res) {
              if (res.data.code == 200) {
                _this7.$message.success('流程已终止');
                _this7.showContinueModal();
              }
            });
          }).catch(function () {
            return void 0;
          });
        }
      });
    },
    showContinueModal: function showContinueModal() {
      this.continueModalVisible = true;
    },
    handleContinue: function handleContinue() {
      this.continueModalVisible = false;
      this.getNextAuditData();
    },
    handleCancelContinue: function handleCancelContinue() {
      this.continueModalVisible = false;
      this.$router.push({
        path: '/formReview/reviewCenter/viewProcess',
        query: {
          procInsId: this.procInsId,
          path: this.path
        }
      });
    },
    getNextAuditData: function getNextAuditData() {
      var _this8 = this;
      queryWaitMeApplys({
        formName: this.searchParams.formName,
        category: this.searchParams.category,
        beginTime: this.searchParams.beginTime,
        endTime: this.searchParams.endTime,
        summary: this.searchParams.summary,
        fillId: this.searchParams.fillId,
        pageSize: 1,
        currentNo: 1
      }).then(function (res) {
        if (res.data.code == 200) {
          var data = res.data.data;
          if (data && data.rows && data.rows.length > 0) {
            var nextRecord = data.rows[0];
            if (nextRecord.taskId && nextRecord.taskId == _this8.taskId) {
              _this8.$message.info('没有更多待审批数据');
              _this8.$router.push({
                path: '/formReview/reviewCenter/viewProcess',
                query: {
                  procInsId: _this8.procInsId,
                  path: _this8.path
                }
              });
              return;
            }
            _this8.procInsId = nextRecord.procInsId;
            _this8.taskId = nextRecord.taskId;
            _this8.sinceFillId = nextRecord.fillId;
            _this8.targetKey = '';
            _this8.flowListRaw = [];
            _this8.mergedFlowList = [];
            _this8.newflowList = [];
            _this8.flowFromData = {};
            _this8.formData = {
              list: [],
              config: {
                labelWidth: 100,
                labelPosition: 'right',
                size: 'small',
                customClass: '',
                ui: 'element',
                layout: 'horizontal',
                labelCol: 3,
                width: '100%',
                hideLabel: false,
                hideErrorMessage: false
              }
            };
            _this8.fillData = {};
            _this8.comment = '';
            _this8.auditUserVisible = false;
            _this8.flowApproverSetList = [];
            _this8.nextAuditUser = '';
            _this8.nextAuditUsers = [];
            _this8.nextAuditUserFlag = false;
            _this8.nextAuditUserType = '';
            _this8.nextAuditGroup = '';
            _this8.hasCustomLabel = false;
            _this8.inputSize = 0;
            _this8.inputKeyList = [];
            _this8.inputTypeList = [];
            _this8.formObject = {
              organPostId: [],
              inputValueList: []
            };
            _this8.options = [];
            _this8.valided = false;
            _this8.currCheck = {
              comment: '',
              userName: '',
              deptName: ''
            };
            _this8.$nextTick(function () {
              _this8.onloadFlowRecord();
            });
          } else {
            _this8.$message.info('没有更多待审批数据');
            _this8.$router.push({
              path: '/formReview/reviewCenter/viewProcess',
              query: {
                procInsId: _this8.procInsId,
                path: _this8.path
              }
            });
          }
        }
      });
    }
  },
  mounted: function mounted() {
    var _this9 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var userinfo;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _this9.procInsId = _this9.$route.query && _this9.$route.query.procInsId;
            _this9.taskId = _this9.$route.query && _this9.$route.query.taskId;
            _this9.path = _this9.$route.query && _this9.$route.query.path;
            _this9.sinceFillId = _this9.$route.query && _this9.$route.query.sinceFillId;
            _this9.searchParams.formName = _this9.$route.query && _this9.$route.query.formName;
            _this9.searchParams.category = _this9.$route.query && _this9.$route.query.category;
            _this9.searchParams.beginTime = _this9.$route.query && _this9.$route.query.beginTime;
            _this9.searchParams.endTime = _this9.$route.query && _this9.$route.query.endTime;
            _this9.searchParams.summary = _this9.$route.query && _this9.$route.query.summary;
            _this9.searchParams.fillId = _this9.$route.query && _this9.$route.query.fillId;
            _this9.$nextTick(function () {
              _this9.onloadFlowRecord();
            });
            userinfo = JSON.parse(localStorage.getItem('admin.user'));
            _this9.signImgUrl = config.baseUrl + userinfo.signImgUrl;
          case 1:
            return _context2.a(2);
        }
      }, _callee2);
    }))();
  }
};